// extracted by mini-css-extract-plugin
var _1 = "trust-bJ7wn";
export { _1 as "trust" }
